import { PureComponent } from 'preact-compat'
import { ContentType } from '@insided/shared/utils/contentType'
import ChangeAuthorModal from './ChangeAuthorModal'

export interface ChangeAuthorOldModerationProps {
  contentType: ContentType
  topicId: number
}

export interface ChangeAuthorOldModerationState {
  showModal: boolean
}

class ChangeAuthorOldModeration extends PureComponent<ChangeAuthorOldModerationProps, ChangeAuthorOldModerationState> {
  constructor(props: ChangeAuthorOldModerationProps) {
    super(props)
    this.onChangeAuthor = this.onChangeAuthor.bind(this)
    this.showModal = this.showModal.bind(this)
    this.hideModal = this.hideModal.bind(this)
  }

  onChangeAuthor() {
    window.location.reload()
  }

  showModal(e: MouseEvent) {
    e.stopPropagation()
    e.preventDefault()
    this.setState({ showModal: true })
  }

  hideModal() {
    this.setState({ showModal: false })
  }

  render() {
    const { contentType, topicId } = this.props
    const { showModal } = this.state
    return (
      <div
        className='change-author'
        onMouseDown={(e) => this.showModal(e)}
      >
        <span>Change author</span>
        {showModal &&
          <ChangeAuthorModal
            contentType={contentType}
            topicId={topicId}
            onChangeAuthor={this.onChangeAuthor}
            onClose={this.hideModal}
          />}
      </div>
    )
  }
}

export default ChangeAuthorOldModeration
